import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Image } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaBriefcase, FaUserTie, FaGraduationCap, FaEnvelope, FaPhoneAlt, FaAward, FaCheckCircle } from 'react-icons/fa';
import './CareerCenter.css';

const CareerCenter = () => {
  const mainColor = '#006186';

  return (
    <div className="career-page bg-white">
      {/* HERO SECTION */}
      <section className="news-hero py-5 border-bottom">
        <Container>
            <h1 className="display-4 fw-bold mb-3 " style={{ color: mainColor }}>
              Карьерный центр
            </h1>
            <div className="header-line mb-4" style={{ backgroundColor: mainColor, width: '80px', height: '5px' }}></div>
            <p className="lead text-muted mb-0" style={{ maxWidth: '850px' }}>
              Основан в 2004 году для содействия профессиональному росту студентов и укрепления связи выпускников с ведущими работодателями.
            </p>
        </Container>
      </section>

      <Container className="py-5">
        {/* О ЦЕНТРЕ И ДОСТИЖЕНИЯ */}
        <Row className="mb-5 g-4 align-items-center">
          <Col lg={7}>
            <h3 className="fw-bold mb-4">Наша миссия</h3>
            <p className="text-secondary">
              Центр карьеры ОшТУ — это структурное подразделение, которое помогает студентам найти работу с максимальными возможностями для самореализации. Мы сотрудничаем с государственными и коммерческими организациями, обеспечивая мост между теорией и практикой.
            </p>
            <div className="p-4 rounded-4 shadow-sm border-start border-5 mb-4" style={{ borderColor: mainColor, backgroundColor: '#f0f7fa' }}>
              <div className="d-flex align-items-center">
                <FaAward className="me-3 fs-2" style={{ color: mainColor }} />
                <div>
                  <h5 className="fw-bold mb-1">Гордость университета</h5>
                  <p className="mb-0 small">Признан <strong>«Самым лучшим Центром Карьеры – 2012»</strong> (1-е место среди вузов Кыргызстана по версии EdNet).</p>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={5}>
            <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
              <div className="p-4 text-center bg-light">
                {/* Заглушка для фото руководителя */}
                <div className="mx-auto mb-3 rounded-circle border border-4 border-white shadow-sm overflow-hidden" style={{ width: '150px', height: '150px', backgroundColor: '#e9ecef' }}>
                   <Image src="Mahabatejeke.png" fluid alt="Ибраева Махабат Кайыповна" />
                </div>
                <h5 className="fw-bold mb-1">Ибраева Махабат Кайыповна</h5>
                <p className="text-muted small mb-3">Заведующая центром карьеры и практики ОшТУ</p>
                <div className="d-grid gap-2">
                  <a href="mailto:kayypovna72@mail.ru" className="text-decoration-none small text-dark">
                    <FaEnvelope className="me-2" style={{ color: mainColor }} /> kayypovna72@mail.ru
                  </a>
                  <a href="tel:+996322243390" className="text-decoration-none small text-dark">
                    <FaPhoneAlt className="me-2" style={{ color: mainColor }} /> +996 (3222) 4-33-90
                  </a>
                </div>
              </div>
            </Card>
          </Col>
        </Row>

        {/* УСЛУГИ ЦЕНТРА */}
        <h2 className="fw-bold mb-4 text-center">Сейчас Центр Карьеры предоставляет:</h2>
        <Row className="g-4 mb-5">
          {[
            { icon: <FaBriefcase />, title: "Поиск вакансий", text: "Сервис по подбору актуальных предложений от партнеров." },
            { icon: <FaUserTie />, title: "Семинары", text: "Мероприятия по развитию навыков успешного трудоустройства." },
            { icon: <FaGraduationCap />, title: "Консультации", text: "Помощь в выборе профессии и создании эффективного резюме." },
            { icon: <FaCheckCircle />, title: "Встречи", text: "Регулярные встречи с успешными выпускниками для обмена опытом." }
          ].map((item, i) => (
            <Col md={3} key={i}>
              <Card className="h-100 border-0 shadow-sm p-3 text-center career-service-card">
                <Card.Body>
                  <div className="fs-2 mb-3" style={{ color: mainColor }}>{item.icon}</div>
                  <h6 className="fw-bold">{item.title}</h6>
                  <p className="text-muted small mb-0">{item.text}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* РАЗДЕЛ ЮНИВОРК */}
        <Card className="border-0 shadow-sm rounded-4 bg-light p-4 p-md-5 mb-5">
          <Row className="align-items-center">
            <Col md={8}>
              <h3 className="fw-bold mb-3">Проект ЮНИВОРК</h3>
              <p className="text-secondary mb-0">
                В рамках международного проекта в библиотеке главного корпуса ОшТУ выделена специализированная аудитория, оснащенная современной оргтехникой и компьютерами для работы студентов над своим карьерным будущим.
              </p>
            </Col>
          </Row>
        </Card>

        {/* НИЖНИЙ БЛОК: КОНСУЛЬТАЦИЯ */}
        <motion.div
          whileHover={{ scale: 1.01 }}
          className="p-5 text-white rounded-4 shadow-lg text-center"
          style={{ backgroundColor: mainColor }}
        >
          <h2 className="fw-bold mb-3 text-uppercase">Нужна помощь в трудоустройстве?</h2>
          <p className="mb-4 opacity-75">Свяжитесь с нами для получения индивидуальной консультации или размещения вакансии.</p>
          <div className="d-flex flex-wrap justify-content-center gap-3">
            <Button as="a" href="tel:+996322243390" variant="light" size="lg" className="fw-bold px-4" style={{ color: mainColor }}>
              <FaPhoneAlt className="me-2" /> (03222) 4-33-90
            </Button>
            <Button as="a" href="mailto:miali_n@mail.ru" variant="outline-light" size="lg" className="fw-bold px-4">
              <FaEnvelope className="me-2" /> miali_n@mail.ru
            </Button>
          </div>
        </motion.div>
      </Container>
    </div>
  );
};

export default CareerCenter;